(() => {
  const legacyHubRedirects = {
    '/pages/huong-thom': '/pages/huong-thom-phong',
    '/pages/huong-thom-v2': '/pages/huong-thom-phong',
    '/pages/giac-ngon': '/pages/giac-ngon-tu-van-nem',
    '/pages/giac-ngon-shop': '/pages/giac-ngon-tu-van-nem',
    '/pages/giac-ngon-products': '/pages/giac-ngon-tu-van-nem',
    '/pages/giac-ngon-tu-van': '/pages/giac-ngon-tu-van-nem',
    '/pages/giac-ngon-finder': '/pages/giac-ngon-tu-van-nem'
  };
  const redirectTarget = legacyHubRedirects[window.location.pathname];
  if (redirectTarget) {
    window.location.replace(redirectTarget);
    return;
  }

  if (window.collectionHubInitialized) return;
  window.collectionHubInitialized = true;

  let activeQuickView = null;
  let quickViewReturnFocus = null;

  const activateFilterMode = (section) => {
    const productGrid = section && section.querySelector('[data-hub-product-grid]');
    if (!productGrid) return;

    productGrid.hidden = false;
    if (section.dataset.hubCuratedStart === 'true') {
      document.documentElement.classList.add('hub-filter-mode');
    }
  };

  const resetCuratedMode = (section) => {
    if (!section || section.dataset.hubCuratedStart !== 'true') return false;

    const productGrid = section.querySelector('[data-hub-product-grid]');
    if (productGrid) productGrid.hidden = true;
    document.documentElement.classList.remove('hub-filter-mode');
    section.querySelectorAll('[data-hub-chip]').forEach((item) => item.classList.remove('is-active'));
    return true;
  };

  const numericPrice = (element, attribute) => {
    const value = Number(element?.dataset?.[attribute] || 0);
    return Number.isFinite(value) ? value : 0;
  };

  const sortProductGridByPrice = (section) => {
    const productGrid = section && section.querySelector('[data-hub-product-grid]');
    if (!productGrid) return;

    [...productGrid.querySelectorAll('[data-hub-product]')]
      .sort((a, b) => numericPrice(a, 'hubProductPrice') - numericPrice(b, 'hubProductPrice'))
      .forEach((item) => productGrid.append(item));
  };

  const sortRailByPrice = (rail) => {
    if (!rail) return;

    [...rail.querySelectorAll('[data-hub-rail-item]')]
      .sort((a, b) => numericPrice(a, 'hubRailPrice') - numericPrice(b, 'hubRailPrice'))
      .forEach((item) => rail.append(item));
  };

  const filterProducts = (section, collectionHandle = '', inStockOnly = false) => {
    const productGrid = section && section.querySelector('[data-hub-product-grid]');
    if (!productGrid) return;

    const products = [...productGrid.querySelectorAll('[data-hub-product]')];
    let visibleCount = 0;

    products.forEach((product) => {
      const collectionHandles = product.dataset.hubProductCollections.split(',');
      const belongsToCollection = !collectionHandle || collectionHandles.includes(collectionHandle);
      const isAvailable = product.dataset.hubProductAvailable === 'true';
      const isVisible = belongsToCollection && (!inStockOnly || isAvailable);
      product.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    const emptyState = productGrid.querySelector('[data-hub-filter-empty]');
    if (emptyState) emptyState.hidden = visibleCount > 0;
  };

  document.querySelectorAll('.collection-hub').forEach(sortProductGridByPrice);
  document.querySelectorAll('[data-hub-rail]').forEach(sortRailByPrice);

  const closeQuickView = () => {
    if (!activeQuickView) return;

    activeQuickView.remove();
    activeQuickView = null;
    document.body.classList.remove('hub-modal-open');
    quickViewReturnFocus?.focus();
    quickViewReturnFocus = null;
  };

  document.addEventListener('click', (event) => {
    const quickViewOpenButton = event.target.closest('[data-hub-quick-view-open]');
    if (quickViewOpenButton) {
      const template = quickViewOpenButton.closest('.hub-card')?.querySelector('[data-hub-quick-view-template]');
      if (!template) return;

      event.preventDefault();
      closeQuickView();
      activeQuickView = template.content.firstElementChild.cloneNode(true);
      quickViewReturnFocus = quickViewOpenButton;
      document.body.append(activeQuickView);
      document.body.classList.add('hub-modal-open');
      activeQuickView.querySelector('.hub-quick-view__close')?.focus();
      return;
    }

    if (event.target.closest('[data-hub-quick-view-close]')) {
      closeQuickView();
      return;
    }

    const scrollButton = event.target.closest('[data-hub-scroll]');
    if (scrollButton) {
      const section = scrollButton.closest('.hub-rail-section');
      const rail = section && section.querySelector('[data-hub-rail]');
      if (!rail) return;

      const direction = Number(scrollButton.dataset.hubScroll);
      rail.scrollBy({
        left: rail.clientWidth * 0.82 * direction,
        behavior: 'smooth'
      });
      return;
    }

    const filterButton = event.target.closest('[data-hub-filter-toggle]');
    if (filterButton) {
      const section = filterButton.closest('.collection-hub');
      const filters = section && section.querySelector('[data-hub-filters]');
      if (!filters) return;

      filters.hidden = !filters.hidden;
      filterButton.setAttribute('aria-expanded', String(!filters.hidden));
      return;
    }

    const chip = event.target.closest('[data-hub-chip]');
    if (chip) {
      const section = chip.closest('.collection-hub');
      const productGrid = section && section.querySelector('[data-hub-product-grid]');
      if (!productGrid) return;

      event.preventDefault();

      if (chip.classList.contains('is-active') && resetCuratedMode(section)) {
        const filters = section.querySelector('[data-hub-filters]');
        const shopAllRadio = filters && filters.querySelector('[data-hub-filter-radio][value=""]');
        if (shopAllRadio) shopAllRadio.checked = true;
        section.querySelector('[data-hub-filter-toggle]')?.setAttribute('aria-expanded', 'false');
        return;
      }

      const collectionHandle = chip.dataset.hubCollectionHandle;
      const showAll = chip.dataset.hubFilterAll === 'true' || !collectionHandle;
      const filters = section.querySelector('[data-hub-filters]');
      const inStockOnly = filters && filters.querySelector('[data-hub-in-stock]')?.checked;
      activateFilterMode(section);
      filterProducts(section, showAll ? '' : collectionHandle, inStockOnly);

      section.querySelectorAll('[data-hub-chip]').forEach((item) => {
        item.classList.toggle('is-active', item === chip);
      });

      const filterRadio = filters && filters.querySelector(`[data-hub-filter-radio][value="${showAll ? '' : collectionHandle}"]`);
      if (filterRadio) filterRadio.checked = true;
      return;
    }

    const applyButton = event.target.closest('[data-hub-filter-apply]');
    if (applyButton) {
      const section = applyButton.closest('.collection-hub');
      const filters = applyButton.closest('[data-hub-filters]');
      const collectionHandle = filters.querySelector('[data-hub-filter-radio]:checked')?.value || '';
      const inStockOnly = filters.querySelector('[data-hub-in-stock]')?.checked || false;

      activateFilterMode(section);
      filterProducts(section, collectionHandle, inStockOnly);
      section.querySelectorAll('[data-hub-chip]').forEach((item) => {
        const itemHandle = item.dataset.hubFilterAll === 'true' ? '' : item.dataset.hubCollectionHandle;
        item.classList.toggle('is-active', itemHandle === collectionHandle);
      });

      filters.hidden = true;
      section.querySelector('[data-hub-filter-toggle]')?.setAttribute('aria-expanded', 'false');
      return;
    }

    const clearButton = event.target.closest('[data-hub-filter-clear]');
    if (clearButton) {
      const section = clearButton.closest('.collection-hub');
      const filters = clearButton.closest('[data-hub-filters]');
      const shopAllRadio = filters.querySelector('[data-hub-filter-radio][value=""]');
      const inStockCheckbox = filters.querySelector('[data-hub-in-stock]');

      if (shopAllRadio) shopAllRadio.checked = true;
      if (inStockCheckbox) inStockCheckbox.checked = false;

      if (resetCuratedMode(section)) {
        filters.hidden = true;
        section.querySelector('[data-hub-filter-toggle]')?.setAttribute('aria-expanded', 'false');
        return;
      }

      filterProducts(section);
      section.querySelectorAll('[data-hub-chip]').forEach((item) => {
        item.classList.toggle('is-active', item.dataset.hubFilterAll === 'true');
      });
    }
  });

  document.addEventListener('change', (event) => {
    const variant = event.target.closest('[data-hub-modal-variant]');
    if (variant) {
      const quickView = variant.closest('[data-hub-quick-view]');
      quickView.querySelectorAll('.hub-quick-view__variant').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(variant));
      });

      const image = quickView.querySelector('.hub-quick-view__image');
      if (image && variant.dataset.image) image.src = variant.dataset.image;

      const price = quickView.querySelector('[data-hub-modal-price]');
      if (price) price.textContent = variant.dataset.price;

      const comparePrice = quickView.querySelector('[data-hub-modal-compare-price]');
      if (comparePrice) {
        comparePrice.textContent = variant.dataset.comparePrice;
        comparePrice.hidden = !variant.dataset.comparePrice;
      }
      return;
    }

    if (!event.target.matches('[data-hub-sort]')) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-hub-modal-form]');
    if (!form) return;

    event.preventDefault();
    const addButton = form.querySelector('[data-hub-modal-add]');
    if (!addButton || addButton.disabled) return;

    const originalText = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    try {
      const cartAddUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Cart request failed');

      addButton.textContent = 'Added to cart';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.setTimeout(closeQuickView, 700);
    } catch (error) {
      addButton.disabled = false;
      addButton.textContent = 'Could not add. Try again';
      window.setTimeout(() => {
        addButton.textContent = originalText;
      }, 1800);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeQuickView();
  });
})();
